export default {
  title: {
    id: 'shopping_assistant_title',
    defaultMessage: 'Ask me',
  },
  newChat: {
    id: 'shopping_assistant_new_chat_button_icon',
    defaultMessage: 'New conversation',
  },
  closeChat: {
    id: 'shopping_assistant_close_chat_button',
    defaultMessage: 'Close conversation',
  },
  chatHistoryButton: {
    id: 'shopping_assistant_chat_history_button_icon',
    defaultMessage: 'See previous conversation',
  },
} as const
